import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MATERIAL_IMPORTS } from '../../../shared/material/material';
import { Atencion, AtencionDashboard, Paciente } from '../../../pages/pacientes/pacientes';
import { DatePipe } from '@angular/common';
import { InicioAtencionService } from '../inicio-atencion.service';

@Component({
  selector: 'app-dashboard-cards',
  standalone: true,
  imports: [...MATERIAL_IMPORTS, DatePipe],
  templateUrl: './dashboard-cards.html',
  styleUrl: './dashboard-cards.scss',
})
export class DashboardCards {
  constructor(private inicioAtencionService: InicioAtencionService) {}

  @Input() pendientes!: number;

  @Input() consultasHoy!: number;

  @Input() restantes!: number;

  @Input() proximaConsulta: Atencion | null = null;

  @Input() totalPendientes = 0;

  @Input() rol: string | undefined;

  @Output() verDetalle = new EventEmitter<void>();

  @Output() verTodos = new EventEmitter<void>();

  mostrarTodos() {
    this.verTodos.emit();
  }

  abrirDashboard() {
    this.verDetalle.emit();
  }

  abrirConsulta(atencion: Atencion): void {
    this.inicioAtencionService.abrirConsulta(atencion);
  }
}
